import cookieManager from '@/utils/cookieManager';

export const createAuthServices = (coreServices) => {
  return {
    async login(data) {
      return coreServices.post('/users/login/', data, '');
    },
    logout() {
      return coreServices.post(
        '/users/logout/',
        { refresh: cookieManager.get('refreshToken') }
      );
    },
    forgotPassword(formData) {
      const header = coreServices.getRequestHeader();
      delete header.Authorization;
      return coreServices.post('/users/forgot-password/', formData, header);
    },
    confirmForgotPassword(formData) {
      const header = coreServices.getRequestHeader();
      delete header.Authorization;
      return coreServices.post('/users/forgot-password/confirm/', formData, header);
    },
    // setNewPassword(formData) {
    //   const headers = coreServices.getRequestHeader();
    //   delete headers.Authorization;
    //   return coreServices.post('/users/password/reset/confirm/', formData, headers);
    // },
    // setNewPasswordUpdated(formData) {
    //   return coreServices.post('/users/set-password-updated/', formData, coreServices.getRequestHeader());
    // },
    // resetPassword(formData) {
    //   const header = coreServices.getRequestHeader();
    //   delete header.Authorization;
    //   return coreServices.post('/users/password/reset/', formData, header);
    // },
    changePassword(formData) {
      return coreServices.post('/users/update-password/', formData, coreServices.getRequestHeader());
    },
    updateExpiredPassword(formData) {
      return coreServices.post('/users/update-expired-password/', formData);
    },
    /**
     * Verify the 2FA code emailed at login
     * @param {string} otp - 6-digit OTP code
     */
    verifyOTP(otp) {
      return coreServices.post('/users/verify-otp/', { otp });
    },
    /** Email a new 2FA code, invalidating the previous one */
    resendOTP() {
      return coreServices.post('/users/resend-otp/', {});
    },
  }
}
